import { isSSR, useWindowSize } from '@visiba/react-std';
import { useCallback, useEffect, useState } from 'react';

export enum BreakPoints {
	Small = 1,
	Medium = 2,
	Large = 4,
}

function retrieveBreakpoint(width: number): BreakPoints {
	if (width <= 905) return BreakPoints.Small;
	if (width <= 1440) return BreakPoints.Medium;

	return BreakPoints.Large;
}

// TODO: Move to Cellula repo.

export function useBreakpoint(): BreakPoints;
export function useBreakpoint(bitWise: number): boolean;
export function useBreakpoint(bitWise?: number): BreakPoints | boolean {
	const { width } = useWindowSize();
	const getBreakpoint = useCallback((): BreakPoints => {
		if (isSSR || width == null) return BreakPoints.Small;

		return retrieveBreakpoint(width);
	}, [width]);
	const [breakpoint, setBreakpoint] = useState(getBreakpoint);

	// biome-ignore lint/correctness/useExhaustiveDependencies: suppressed due to migration - should be fixed
	useEffect(() => {
		setBreakpoint(getBreakpoint);
	}, [width, getBreakpoint]);

	if (bitWise != null) {
		return (breakpoint & bitWise) === breakpoint;
	}

	return breakpoint;
}
